// apps/client/src/utils/subscription.ts

import { SubscriptionData } from '@avanzu/types';
import { apiClient } from './apiClient';

export const fetchSubscription = async (): Promise<SubscriptionData | null> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }

  const response = await apiClient.get(`/organisations/${organisationId}/stripe/subscriptions`);

  // Treat "no subscription" / endpoint gone as a normal "nothing here" state,
  // not an error. In the per-project billing model there are no subscriptions
  // at all, and even in the legacy model a fresh org has none.
  if (response.status === 204 || response.status === 404 || response.status === 410) {
    return null;
  }

  if (!response.ok) {
    // Don't surface other errors to the user — billing UI degrades gracefully
    // when subscription data is unavailable.
    console.warn(`fetchSubscription: unexpected status ${response.status}`);
    return null;
  }

  return response.json();
};

export const cancelSubscription = async (): Promise<void> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }
  const response = await apiClient.delete(`/organisations/${organisationId}/stripe/subscriptions`);

  if (!response.ok) {
    throw new Error('Failed to cancel subscription');
  }
};

export const reactivateSubscription = async (): Promise<void> => {
  const organisationId = localStorage.getItem('organisationId') || '';
  if (!organisationId) {
    throw new Error('No organisation selected');
  }

  const response = await apiClient.put(
    `/organisations/${organisationId}/stripe/subscriptions/reactivate`
  );

  if (!response.ok) {
    throw new Error('Failed to reactivate subscription');
  }
};
